import InputView from "../view/input.js";

import {
  SliderTrigger
} from "../../const.js";
export default class Input {
  constructor(element, type, sliderPresenter) {
    this._element = element;
    this._type = type;
    this._sliderPresenter = sliderPresenter;

    this._view = null;
    this._relatedPresenter = null;
    this._notEmpty = false;
    this._inputsValues = {
      beforeFocus: {
        from: 0,
        to: 0
      }
    };

    this._handleInputInput = this._handleInputInput.bind(this);
    this._handleInputFocus = this._handleInputFocus.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
    this._afterResetClick = this._afterResetClick.bind(this);
  }

  init(relatedPresenter) {
    this._relatedPresenter = relatedPresenter;

    this._view = new InputView(this._element);

    this._view.setInputHandler(this._handleInputInput);
    this._view.setFocusHandler(this._handleInputFocus);
    this._view.setBlurHandler(this._handleInputBlur);

    this._sliderPresenter.getResetPresenter().addObserver(this._afterResetClick);
  }

  getElement() {
    return this._view.getElement();
  }

  getMin() {
    return this._view.getMin();
  }

  getMax() {
    return this._view.getMax();
  }

  getValue() {
    return this._view.getValue();
  }

  setValue(value) {
    return this._view.setValue(value);
  }

  getName() {
    return this._view.getName();
  }

  getPlaceholder() {
    return this._view.getPlaceholder();
  }

  setPlaceholder(value) {
    return this._view.setPlaceholder(value);
  }

  getDefault() {
    return this._view.getDefault();
  }

  _afterResetClick() {
    this.setValue(null);
    this.setPlaceholder(this.getDefault());
  }

  _handleInputInput() {
    this._notEmpty = true;

    let newValue = this.getValue();

    const sliderData = this._sliderPresenter.getSliderData();

    switch (this._type) {
      case SliderTrigger.FROM:
        const min = sliderData.min;

        if (newValue === 0) {
          newValue = min;
        }

        newValue = (newValue < min) ? min : newValue;
        newValue = (newValue > this._relatedPresenter.getValue()) ? this._relatedPresenter.getValue() : newValue;
        break;
      case SliderTrigger.TO:
        const max = sliderData.max;

        if (newValue === 0) {
          newValue = max;
        }

        newValue = (newValue > max) ? max : newValue;
        newValue = (newValue < this._relatedPresenter.getValue()) ? this._relatedPresenter.getValue() : newValue;
        break;
    }

    this.setValue(newValue);
    this.setPlaceholder(newValue);
    this._sliderPresenter.changeSliderFromInput(this._type, newValue);
  }

  _handleInputFocus() {
    const defaultThis = this.getDefault();
    const placeholderThis = this.getPlaceholder();
    const valueThis = (defaultThis !== placeholderThis) ?
      placeholderThis :
      defaultThis;

    const defaultRelated = this._relatedPresenter.getDefault();
    const placeholderRelated = this._relatedPresenter.getPlaceholder();
    const valueRelated = (defaultRelated !== placeholderRelated) ?
      placeholderRelated :
      defaultRelated;

    if (this.getValue() && this._relatedPresenter.getValue()) {
      this._notEmpty = true;
      return;
    }

    if (!this.getValue()) {
      this.setValue(valueThis);
    }

    if (!this._relatedPresenter.getValue()) {
      this._relatedPresenter.setValue(valueRelated);
    }

    this._inputsValues.beforeFocus.from = valueThis;
    this._inputsValues.beforeFocus.to = valueRelated;
  }

  _handleInputBlur() {
    if (this._sliderPresenter.getIsHoldedOnce() || this._notEmpty) {
      return;
    }

    if (
      this.getValue() === this._inputsValues.beforeFocus.from &&
      this._relatedPresenter.getValue() === this._inputsValues.beforeFocus.to
    ) {
      this.setValue(null);
      this._relatedPresenter.setValue(null);
    }
  }
}
